import { FormEvent, useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import LogoEmpresa from "../../assets/img/empresa.png";
import { criptografarDado } from "../../helpers";
import { ListaDeProcessoSeletivo } from "../../interfaces/processoSeletivo";
import { listarProcessosInscritos } from "../../services/processoSeletivo";
import NenhumResultadoEncontrado from "../NenhumResultadoEncontrado";
import Notificacoes from "../Notificacoes";
import { Button, Loader } from "../styles";
import "./processosInscritos.css";

function ProcessosInscritos() {
  const [processando, setProcessando] = useState(false);
  const [nenhumResultado, setNenhumResultado] = useState(false);
  const [nomeFantasia, setNomeFantasia] = useState("");
  const [situacao, setSituacao] = useState("");
  const [processosInscritos, setProcessosInscritos] = useState<ListaDeProcessoSeletivo[]>([]);
  const [erroProcessoInscrito, setErroProcessoInscrito] = useState(false);
  const [tituloCargo, setTituloCargo] = useState("");

  const buscarProcessosInscritos = async (e?: FormEvent) => {
    e?.preventDefault();
    setProcessando(true);
    try {
      const query = {
        situacao,
        nomeFantasia,
        tituloCargo
      }
      const resposta = await listarProcessosInscritos(query);
      if (resposta.status === 200) {
        setProcessosInscritos(resposta.data);
      }
      if (resposta.data.length === 0) {
        setNenhumResultado(true);
      }
    } catch {
      setErroProcessoInscrito(true);
      setNenhumResultado(true);
      setTimeout(() => setErroProcessoInscrito(false), 5000);
    } finally {
      setProcessando(false);
    }
  };

  useEffect(() => {
    buscarProcessosInscritos();
  }, []);

  return (
    <>
      <Outlet />
      {erroProcessoInscrito && <Notificacoes cor={"erro"} texto={"Erro ao listar Processos inscritos."} />}
      <section className="pi-container-principal">
        <form className="pi-filtro-area" onSubmit={buscarProcessosInscritos}>
          <input
            type="text"
            className="pi-input-filtro"
            value={nomeFantasia}
            placeholder="Filtrar pela empresa"
            onChange={(e) => setNomeFantasia(e.target.value)}
          />
          <input
            type="text"
            className="pi-input-filtro"
            value={tituloCargo}
            placeholder="Filtrar pela titulo do cargo"
            onChange={(e) => setTituloCargo(e.target.value)}
          />

          <select
            className="pi-input-filtro"
            value={situacao}
            onChange={(e) => setSituacao(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="Participando">Participando</option>
            <option value="Aprovado">Aprovado</option>
            <option value="Reprovado">Reprovado</option>
          </select>

          <Button
            isCancelar={false}
            type="submit"
            cor="continuar"
            isLoading={processando}
          >
            {!processando ? 'Filtrar' : <Loader isLoading={processando} />}
          </Button>
        </form>
        {nenhumResultado && processosInscritos.length === 0 ? (
          <div style={{ margin: "auto" }}>
            <NenhumResultadoEncontrado />
          </div>
        ) : (
          <section className="pi-grid-vagas">
            {processosInscritos.map((processo) => {
              const statusLabel = processo.processoInscritos[0]?.situacaoCandidatura || "Participando";

              return (
                <div key={processo.id} className="pi-card-processo">
                  <div className="pi-card-topo">
                    <img
                      src={processo.cadastro.avatar ? processo.cadastro.avatar : LogoEmpresa}
                      className="pi-logo-empresa"
                      alt="Logo Empresa"
                    />
                    <div>
                      <h3 className="pi-titulo-vaga">{processo.titulo}</h3>
                      <p className="pi-texto-empresa">{processo.cadastro.nomeFantasia}</p>
                      <p className="pi-texto-local">{processo.localTrabalhoCidade} - {processo.localTrabalhoEstado}</p>
                    </div>
                  </div>

                  <div className="pi-container-tags">
                    <span className="pi-tag-item">{processo.modalidadeTrabalho}</span>
                    <span className="pi-tag-item">R$ {processo.salario}</span>
                    <span className="pi-tag-item">{processo.regimeContratacao}</span>
                    <span className="pi-tag-item">{processo.formacaoAcademica}</span>
                  </div>

                  <div className="pi-card-rodape">
                    <Link to={`/processos-inscritos/${criptografarDado(processo.id.toString())}`} className="pi-btn-link">
                      Detalhes da vaga
                    </Link>
                    <div className={`pi-status-badge ${statusLabel.toLowerCase()}`}>
                      {statusLabel}
                    </div>
                  </div>
                </div>
              );
            })}
          </section>
        )}
      </section>
    </>
  );
}

export default ProcessosInscritos;